import { useRouter, useSearchParams } from 'next/navigation'

export const useLoadMore = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const loadMore = () => {
    const currentParams = new URLSearchParams(searchParams!.toString())
    const currentPage = Number(currentParams.get('page') || '1')
    currentParams.set('page', (currentPage + 1).toString())
    router.push(`?${currentParams.toString()}`, {
      scroll: false,
    })
  }

  return { loadMore }
}
